import { render, staticRenderFns } from "./StakeeMobileBlock.vue?vue&type=template&id=6f38960e"
import script from "./StakeeMobileBlock.vue?vue&type=script&lang=js"
export * from "./StakeeMobileBlock.vue?vue&type=script&lang=js"
import style0 from "./StakeeMobileBlock.vue?vue&type=style&index=0&id=6f38960e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports